module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAAXNSR0IArs4c6QAAAGJJREFUKBVj+E8cKGJABiA9yHx0NtTMW0C6DC5HpCYpoLobQFwF0sgC142HwcjI+AyowQGoZB+QZmEEEv+Bgoy49IDkMeSwCmKoQgiA1DMhuMSzRjVBw2qQBwQ4GREfrRCVAA0ZZNZGgkTVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon__paper--white.png
// module id = Kdzj
// module chunks = 1